import './UsersPageModals.scss';

import React from 'react';
import Modal from 'components/Modal';

import ModalButton from 'components/ModalButton';
import SlideList from 'components/SlideList';
import UserDetails from 'components/UserDetails';

import { ASSIGNMENT_STATUSES } from 'containers/AssignmentsPage/constants';
import { MODALS } from 'utils/constants';

export default class UserDetailsModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        deleteUser: React.PropTypes.func.isRequired,
        isFetchingAssignments: React.PropTypes.bool.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        openModal: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        user: React.PropTypes.object.isRequired
    };

    /**
     * @desc    returns the total count of all assignments in the
     *          new user assignmentIds object. If no assignmentIds yet,
     *          this returns '--' for display until GET is completed
     * @returns string or int - the count of all assignments for the user
     */
    _generateAssignmentCount() {
        if(this.props.user.assignmentIds != null && this.props.user.assignmentIds.entry != null) {
            let count = 0;
            this.props.user.assignmentIds.entry.forEach((set) => {
                console.log(set);
                if (set.ints != null && ['draft', 'stopped'].indexOf(set.key) === -1) {
                    count += set.ints.length;
                }
            });
            return count;
        } else {
            return '--';
        }
    }

    /**
     * @desc    Generates the array of objects needed to display the
     *          count bubbles on the assignments slidelist
     * @returns array - The data for the count bubbles
     */
    _generateBubbleCounts() {
        if(this.props.user.assignmentIds != null && this.props.user.assignmentIds.entry != null) {
            let counts = [];
            this.props.user.assignmentIds.entry.forEach((set) => {
                if([ASSIGNMENT_STATUSES.OVERDUE, ASSIGNMENT_STATUSES.PARTIAL_PROGRESS, ASSIGNMENT_STATUSES.COMPLETE].indexOf(set.key) !== -1) {
                    let count = {}
                    count.type = set.key;
                    if (set.ints != null) {
                        count.count = set.ints.length;
                    } else {
                        count.count = 0;
                    }
                    counts.push(count);
                }
            });
            return counts;
        } else {
            return [];
        }
    }

    render() {
        let { closeModal, deleteUser, isFetchingAssignments, isSaving, openModal, show, user } = this.props;

        if(Object.keys(user).length > 0 && user.id !== undefined) {
            return (
                <Modal show={show && Object.keys(user).length > 0 && user.id !== undefined}
                       className="user-details"
                       handleClose={closeModal.bind(this)}>

                    <UserDetails
                        infoClassName="details-modal__info"
                        user={user}
                    />

                    <SlideList bubbleCounts={this._generateBubbleCounts()}
                               className="user-details__assignments-list user-details__list"
                               count={this._generateAssignmentCount()}
                               icon="assignments"
                               isFetching={isFetchingAssignments}
                               items={user.assignments || []}
                               user={user}
                               title="Assignments"
                               type="assignments" />

                    <SlideList className="user-details__groups-list user-details__list"
                               count={user.department ? 1 : 0}
                               icon="groups"
                               items={user.department ? [user.department] : []}
                               title="Groups"
                               type="groups" />

                    <div className="modal__buttons">
                        <ModalButton disabled={isSaving === true}
                                     icon="edit"
                                     onClick={openModal.bind(this, MODALS.USER_EDIT)}
                                     text="Edit" />
                        <ModalButton disabled={isSaving === true}
                                     icon="delete"
                                     onClick={deleteUser.bind(this, user)}
                                     text="Remove" />
                    </div>

                </Modal>
            )
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/UsersPage/modals/UserDetailsModal.js